import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDKTvtM_5ESgk-L6LRq77DSH9GTKlL9V98",
  authDomain: "taarteb.firebaseapp.com",
  projectId: "taarteb",
  storageBucket: "taarteb.firebasestorage.app",
  messagingSenderId: "204748308574",
  appId: "1:204748308574:web:c9a6afa0ebb8a75c9074cf",
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);
